<template lang="pug">
  .step-wrap(:class="finalClasses" @click="handleClick")
    .step-circle.bold {{ number }}
      mr-icon(name="check-icon")
    .info-wrap
      span.bold {{ title }}
      .info.mister-color-3.underline.mt-8(v-if="showInfo")
        slot
</template>

<script>
  export default {
    name: "StepCircle", props: {
      stateClass: {
        type: String,
        default: ""
      },
      number: {
        type: String,
        required: true
      },
      title: {
        type: String,
        required: true,
      },
      showInfo: {
        type: Boolean,
        default: false
      },
      hideLine: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      }

    },
    computed: {
      finalClasses() {
        return {
          [this.stateClass]: !!this.stateClass,
          'pre-line': !this.hideLine,
          clickable: this.clickable,
        };
      },
      clickable() {
        return this.stateClass === 'done' && !this.disabled;
      }
    },
    methods: {
      handleClick() {
        if (this.clickable) {
          this.$emit('click');
        }
      }
    }

  };
</script>

<style scoped lang="stylus">
  .step-wrap
    flex 1
    position relative
    min-width 55px
    display flex
    flex-direction column
    align-items center
    
    &.clickable
      cursor pointer

    &.pre-line::before
      content ''
      position absolute
      top 14px
      left -50%
      height 3px
      width 100%
      background-color ui-color-5

    &.pre-line::after
      content ''
      position absolute
      top 14px
      left -50%
      height 3px
      width 0%
      transition 1s
      background-color cta-color-1

    &.active::after,&.done::after
      width 100%

    .info-wrap
      display flex
      flex-direction column
      justify-content space-between
      align-items center
      margin-top 8px
      text-align center

      .info
        display flex
        flex-direction column
        align-items center


    .step-circle 
      position relative
      z-index 1
      width 30px;
      height 30px;
      background-color ui-color-1
      border 3px solid ui-color-5
      border-radius 50%
      display flex
      justify-content center
      align-items center
      font-size 14px
      transition 0.4s
      
      svg
        opacity 0
        position absolute
        top 10%
        left 10%
        width 85%
        height 85%
        background-color transparent
        stroke ui-color-1
        transition 1s
        transition-delay background-color 0.5s

    &.active,&.done
      .info-wrap
        color cta-color-1
      .step-circle
        border 3px solid cta-color-1
        color cta-color-1

    &.done
      .step-circle
        background-color cta-color-1
      
      svg
        opacity 1
        stroke cta-color-1
        color ui-color-1

  @media mq-tablet-less
    .step-wrap
      &.pre-line::before
        top 12px
      &.pre-line::after
        top 12px

      .step-circle
        width 24px
        height 24px
</style>